export enum ModeNamesEnum {
  Videos = 'videos',
  Gps = 'gps-tracks',
  Workouts = 'structured-trainings',
  Coachings = 'coached-trainings',
  Library = 'my-library',
}

export interface BrowseMode {
  name: ModeNamesEnum;
  icon: string;
}

export const MODES: BrowseMode[] = [
  { name: ModeNamesEnum.Videos, icon: 'video' },
  { name: ModeNamesEnum.Gps, icon: 'mode-GPS-new' },
  { name: ModeNamesEnum.Workouts, icon: 'mode-interval' },
  { name: ModeNamesEnum.Coachings, icon: 'coaching-new' },
  { name: ModeNamesEnum.Library, icon: 'like' },
];
